import { TranslationsContext } from '@teliaee/telia-translate';
import { observer } from 'mobx-react';
import React from 'react';
import { CardContent, Card, Check, Notice, Separator, Text } from 'telia-front-react';
import { useStores } from '../stores/RootStore';

const TechnicianInformationBox = observer((): React.JSX.Element => {
  const {
    reservationStore: { requireTechnician, setRequireTechnician }
  } = useStores();
  const { translate } = React.useContext(TranslationsContext);

  const technicianRequiredText: string = translate('reservation.technician.supportRequired');
  const technicianPricingText: string = `${translate('reservation.technician.price', { minutes: 15, price: 10 })}\u20ac`;
  const helpTextForTheVisuallyImpaired: string = `${technicianRequiredText}. ${technicianPricingText}`;

  return (
    <Card>
      <CardContent>
        <Text>
          <Notice size="small">{translate('reservation.technician.information')}</Notice>
          <Separator spacing="xxsmall" color="invisible" />
          {translate('reservation.technician.description')}
          <Separator spacing="xxsmall" color="invisible" />
          <Check
            id="technician-support-required"
            value="technician-support-required"
            labelText={helpTextForTheVisuallyImpaired}
            onChange={setRequireTechnician}
            checked={requireTechnician}
          >
            <span>{technicianRequiredText}&nbsp;</span>
            <span className="text-light">({technicianPricingText})</span>
          </Check>
          <Notice size="small">
            <p className="text-light text-small">{translate('reservation.technician.notice')}</p>
          </Notice>
        </Text>
      </CardContent>
    </Card>
  );
});

export default TechnicianInformationBox;
